import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/phone.png'


const _withScopeId = n => (_pushScopeId("data-v-50b59948"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "c-preview" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "phone",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "preview" }
const _hoisted_4 = ["src"]

import { withDefaults, ref } from 'vue';
import { useShareWebviewTaskUrl } from '@hooks/webview';


export default /*#__PURE__*/_defineComponent({
  __name: 'c-preview',
  props: {
    projectId: {},
    projectType: {},
    informationId: {},
    taskId: {},
    showType: {},
    targetType: {}
  },
  setup(__props: any) {

const props = __props;

// C端预览地址
const ifrSrc = ref(
  useShareWebviewTaskUrl({
    projectId: props.projectId,
    projectType: props.projectType,
    informationId: props.informationId,
    taskId: props.taskId,
    showType: props.showType || 'information',
    targetType: props.targetType || 4
  })
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("iframe", {
        id: "iframe",
        src: ifrSrc.value,
        frameborder: "0",
        scrolling: "no",
        width: "355px",
        height: "670px"
      }, null, 8, _hoisted_4)
    ])
  ]))
}
}

})